module.exports = __webpack_public_path__ + "img/tf2_killstreakkit_professional.345c4208.png";